import { CreateFedexPickupRequest, FedexRateResponseRaw, FedexRequest, FedexShipResponseRaw } from "types/fedexTypes";
import { API } from "./api";

export async function cotarFEDEX(payload: FedexRequest) {
    const { data } = await API.post<FedexRateResponseRaw>("/api/fedex/rating", payload);
    return data;
}

// ----- SHIPPING -----
export async function emitirFEDEX(payload: FedexRequest) {
    const { data } = await API.post<FedexShipResponseRaw>("/api/fedex/shipping", payload);
    return data;
}

// ----- TRACKING -----
export async function rastrearFEDEX(tn: string) {
    return (await API.post(`/api/fedex/tracking/${encodeURIComponent(tn)}`)).data;
}

export async function pickupCreateFEDEX(payload: CreateFedexPickupRequest) {
    const { data } = await API.post(`/api/fedex/pickup`, payload);
    return data;
}